import React from "react";

export default function About() {
  return (
    <section
      id="about"
      className="w-full h-full py-[18vh] bg-[rgb(209,220,223)]"
    >
      <h1 className="title-font sm:text-4xl text-3xl font-medium text-center">
        Hello, Earthling.
      </h1>
      <p className="text-xl leading-relaxed p-8 ml-8 mr-8 sm:ml-32 sm:mr-32 md:ml-44 md:mr-44 lg:ml-60 lg:mr-60 bg-white/60 rounded-3xl">
        Since the age of 7, I have been fascinated with computers and
        programming. My neighbor was a computer wizard, who opened the portal to
        this evolving passion. I started making index cards for terms such as
        CPU, RAM, and ROM to memorize for fun. Later, I was able to attach a
        mental image to these components when he showed me his top-of-the-line
        gaming rig. I knew right then and there that I had to build a computer
        for myself one day.
        <br></br>
        <br></br>
        Fast forward to 2011. I checked 2 items off of my bucket list. I built
        my gaming computer and I graduated from Towson University with a
        Bachelor's in Electronic Media & Film and Computer Science. For the next
        2 years, I did small freelance gigs involving graphic design and motion
        graphics. In November 2013, I got the biggest job of my career at NBC
        Arthouse, which later turned into my current full-time career in June
        2015.
        <br></br>
        <br></br>
        Throughout the decade, working in the broadcast industry has been an
        amazing journey for developing my skills and my character. I was
        introduced to daily graphics for news coverage and gradually navigated
        into more demanding projects that tested my knowledge and creativity.
        For instance, working with a team to create the current Hurricane
        package and winning a silver Telly award for a 3D animation about winter
        driving. I was eager to tinker with programming, but I didn't know where
        or how I could apply my passion.
        <br></br>
        <br></br>I discovered the InTouch touchscreen system and I self-taught
        JavaScript and React to develop apps for stations. At first, I was
        overwhelmed, but I slowly pushed through and overcame many hurdles.
        Learning a new language, new library, and manipulating elements with
        only code to name a few. Eventually, I started building apps to help
        cover topics such as the FIFA World Cup and the weather forecast. I
        became very fluent with the InTouch system and my design expertise
        blended perfectly.
        <br></br>
        <br></br>
        Reflecting on my accomplishments now, I am enthusiastic to see what
        doors open next in my career of design and programming.
      </p>
    </section>
  );
}
